import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SidebarLayout from './SidebarLayout';
import ListaMasajistas from './ListaMasajistas';
import ReservarTurno from './ReservarTurno';
import MisTurnos from './MisTurnos';

const DashboardPaciente = () => {
    const menuItems = [
        {
            path: '/paciente/nuevo-turno',
            icon: '📅',
            label: 'Nuevo Turno',
            description: 'Reservar un turno'
        },
        {
            path: '/paciente/mis-turnos',
            icon: '📋',
            label: 'Mis Turnos',
            description: 'Ver mis reservas'
        },
        //{path: '/perfil', icon: '👤', label: 'Mi Perfil', description: 'Datos personales' },
    ];

    return (
        <SidebarLayout menuItems={menuItems} subtitle="Panel Paciente">
            <Routes>
                <Route index element={<Navigate to="nuevo-turno" replace />} />
                <Route path="nuevo-turno" element={<ListaMasajistas />} />
                <Route path="reservar/:id" element={<ReservarTurno />} />
                <Route path="mis-turnos" element={<MisTurnos />} />
            </Routes>
        </SidebarLayout>
    );
};

export default DashboardPaciente;